import { styled } from '@mui/system'
import { Typography } from '@mui/material'

export const StatisticsPageMain = styled('main')(() => ({
  justifyContent: 'center',
  boxSizing: 'border-box',
  minHeight: 'calc(100vh - 5rem - 5rem)',
  padding: '1.6rem',
  background: 'rgba(0,0,0,0.05)',
}))

export const StatisticsPageTitle = styled(Typography)(({ theme }) => ({
  marginBottom: '2.4rem',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.8rem',
  },
}))

export const StatisticsPageTilesGrid = styled('section')(({ theme }) => ({
  justifyContent: 'center',
  textAlign: 'center',
  gridTemplateColumns: 'repeat(auto-fit, minmax(20rem, 1fr))',
  gridGap: '1.6rem',
  display: 'grid',
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(auto-fill, minmax(18rem, 1fr))',
  },
}))
